import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpModelFilterableBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-model-filterable-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { WizardElementsFilterMenuComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-elements-filter-menu.component';

@Component({
  selector: 'app-wizard-simulateur-filter-menu',
  templateUrl: '../../base/wizard/wizard-elements-filter-menu.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', '../../base/wizard/wizard-elements-filter-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizardHpModelFilterSimulateurComponent extends WizardElementsFilterMenuComponent implements OnInit {
  @Input() simulateurComponent: SimulateurComponent;
  @Input() questionSource : any;

  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setLinkedFilterable(this.simulateurComponent);
  }


  getLocalStorageKey() {
    return 'SimulateurWizardElementsFilterMenuComponent';
  }

  getStoreSelectionInLocalStorage() {
    return true;
  }

  onFilterChangeDataReceived(result: any) {

    if (this.getFilterable() != null) {
      if (this.questionSource != null) {
        result.callback_prms = this.questionSource;
      }
      this.getFilterable().onDataRetrieved(result);
      this.getHpService().emitDataChange();
    }
    
  }

}
